export default __webpack_public_path__ + "static/media/logo.53d7f85b.png";